import PriceSchemeDetail from "@/views/custom/PriceSchemeDetail";

export default {
  key: "price_scheme",
  id: "id",
  export: ["excel"],
  excel: {
     //max_row: "50000" 
  },
  sort_fields: [
    "id",
    "name",
    "fee",
    "locId",
    "maxChargingUnit",
    // "point",
    "type",
    "version"
  ],
  filters: {
    id: {},
    name: {},
    fee: {},
    type: {
      type: "select",
      label: "name",
      value: "code",
    },
    locId: {
      type: "select",
      label: "address",
      value: "loc_id",
    },
    locId: {},
    maxChargingUnit: {},
    // point: {},
    type: {},
    version: {}
  },
  fields: [
    { key: "id", width: 40},
    { key: "name", width: "8%"},
    { key: "fee", width: "8%", forceUpdate:true},
    { key: "locId", width: "8%", type: "select"},
    { key: "maxChargingUnit", width: "8%", forceUpdate:true},
    // { key: "point", width: "8%"},
    { key: "type", width: "8%", type: "select"},
    { key: "version", width: "8%"},
    { type: "action-btn", width: 100 },
    { key: "priceSchemeDetail", type: "componentColumn", component: PriceSchemeDetail, hidden: ["list"],},
  ],
  structure: [
    ["name","locId"],
    ["type","maxChargingUnit"],
    ["fee"],
    ["priceSchemeDetail"],
  ],
  action: ["create","edit"],
  // action: ["create","edit","view","delete"],
  options: {
    type: {
      key: "priceSchemeTypeCode",
      label: "name",
      value: "code"
    },
    locId: {
      key: "cp_locs",
      label: "address",
      value: "loc_id"
    },
  },
  view: [],
  extra_components: {
  },
  disabled_by_column:{
  },
  extra_privillege_components: {
  }
}